import * as React from "react";
import {UIState} from "data/UIState";

export const PlatformNotOpenYet = () =>
  <>
    <p>Platform opens for registration on {UIState.settings.PLATFORM_OPEN_FOR_REG_DATE}.</p>
  </>
;
